import type { Tool } from '../tool';

export function validateClientToolSearchSupport(tools: Tool<any>[]): void {
  void tools;
  return;
}

export function getClientToolSearchHelper<TContext>(
  tools: Tool<TContext>[],
): Tool<TContext> | undefined {
  void tools;
  return undefined;
}
